// var codeCookieValue;
// var getCookie = function(name) {
//   var value = "; " + document.cookie;
//   var parts = value.split('; '+name+'=');
//   if (parts.length == 2) return parts.pop().split(";").shift();
// };
// codeCookieValue = getCookie('discount_code');
// if(!codeCookieValue){
//   console.log("No Discount Code");
// }
// if(codeCookieValue){
//   console.log("Discount Code - " + codeCookieValue);
// }

// fetch('http://127.0.0.1:9292/cart/checkout')
// .then((response) => response.text())
// .then((responseText) => {
//   const html = new DOMParser().parseFromString(responseText, 'text/html');
//   console.log(html);
//   const source2 = html.getElementById('order-summary');
//   console.log(source2);

//   return false;
//   const source = html.getElementById(id);

//   if (source && destination) destination.innerHTML = source.innerHTML;

//   const price = document.getElementById(`price-${this.dataset.section}`);

//   if (price) price.classList.remove('visibility-hidden');
//   this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
// });

document.addEventListener('change', (event) => {
  const input = event.target;

  // Only react to variant radios
  if (
    input.type !== 'radio' ||
    input.dataset.change !== 'variant'
  ) return;

  const cartRoot = input.closest('.cart-items');
  if (!cartRoot) return;

  const line = Number(input.dataset.index);
  if (!line) return;

  const variantRadios = input.closest('cart-variant-radios');
  if (!variantRadios) return;

  const fieldset = input.closest('fieldset');
  const details = fieldset.querySelector('details');

  /* --------------------------------------------
     Update selected label text in summary
  --------------------------------------------- */
  const checkedInput = fieldset.querySelector('input:checked');
  if (checkedInput) {
    const labelHTML = checkedInput.nextElementSibling.innerHTML;
    fieldset.querySelector('.cart__product-select').innerHTML = labelHTML;
  }

  /* --------------------------------------------
     Get variant JSON
  --------------------------------------------- */
  const variantsJSON = variantRadios.querySelector(
    'script[type="application/json"]'
  );
  if (!variantsJSON) return;

  const variants = JSON.parse(variantsJSON.textContent);

  /* --------------------------------------------
     Find selected variant
  --------------------------------------------- */
  const selectedOptions = Array.from(
    variantRadios.querySelectorAll('fieldset')
  ).map(fs => {
    const checked = fs.querySelector('input:checked');
    return checked ? checked.value : null;
  });

  const newVariant = variants.find(v =>
    v.options.every((opt, i) => opt === selectedOptions[i])
  );

  if (!newVariant) return;

  /* --------------------------------------------
     Get current line item data
  --------------------------------------------- */
  const cartItem = input.closest('[data-variant-id]');
  if (!cartItem) return;

  const currentVariantId = cartItem.dataset.variantId;
  const quantity = Number(cartItem.dataset.quantity);

  /* --------------------------------------------
     Close dropdown
  --------------------------------------------- */
  if (details) details.open = false;

  /* --------------------------------------------
     Update cart
  --------------------------------------------- */
  const body = JSON.stringify({
    updates: {
      [currentVariantId]: 0,
      [newVariant.id]: quantity
    },
    sections: [
      'main-cart-items',
      'main-cart-footer',
      'cart-icon-bubble'
    ],
    sections_url: window.location.pathname
  });

  fetch(routes.cart_update_url, {
    ...fetchConfig(),
    body
  })
    .then(res => res.text())
    .then(state => {
      const parsedState = JSON.parse(state);

      /* --------------------------------------------
         Replace cart sections
      --------------------------------------------- */
    //   ['main-cart-items', 'main-cart-footer', 'cart-icon-bubble'].forEach(id => {
    //     const container = document.getElementById(id);
    //     if (!container || !parsedState.sections[id]) return;

    //     const html = new DOMParser()
    //       .parseFromString(parsedState.sections[id], 'text/html')
    //       .body.innerHTML;

    //     container.innerHTML = html;
    //   });
    })
    .catch(console.error);
});
